import React from 'react';
import { DownloadPdfButton } from '../components/form/downloadPdfButton';
import { FaCheckCircle } from "react-icons/fa";
import './rfiComplete.css';

export const RfiCompletedPage = ({rfi, attachments, openNewForm}) => {
  return (
    <div className="rfi-complete-container">
      <div className="text-wrapper">
        <FaCheckCircle size={50} className="check-icon"/>
        <p className="bold-text">Thank you for filling out the form.</p>
        <p className="text">PNNL is processing your request and will respond as soon as possible.</p>
        <p className="text">Please download a copy of the form for your records.</p>
      </div>
      <div className="button-wrapper">
        <DownloadPdfButton 
          formData={rfi} 
          isInternal={false} 
          attachments={attachments} />
        <CreateNewRfiButton onClick={openNewForm}/>
      </div>
    </div>
  )
}

const CreateNewRfiButton = ({onClick}) => {
  return (
    <button 
      onClick={onClick}
      className="submit-button">
        Start New Form
    </button>
  )
}